module.exports = __webpack_public_path__ + "static/media/55_000047.7c48227e.jpg";